import { render, staticRenderFns } from "./myprofile.vue?vue&type=template&id=76586696&scoped=true"
import script from "./myprofile.vue?vue&type=script&lang=js"
export * from "./myprofile.vue?vue&type=script&lang=js"
import style0 from "./myprofile.vue?vue&type=style&index=0&id=76586696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76586696",
  null
  
)

export default component.exports